import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59864eae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-cy"]
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content_left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "11",
  viewBox: "0 0 10 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.5 5.5L0.5 10.2631V0.73686L9.5 5.5Z",
    fill: "white"
  })
], -1))
const _hoisted_5 = {
  key: 0,
  class: "content_right"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "progress_bar" }
const _hoisted_8 = { class: "progress_text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "100%", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_renew_course_mobile = _resolveComponent("as-renew-course-mobile")!
  const _component_as_modal_critical_renew = _resolveComponent("as-modal-critical-renew")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["asCourseCard", _ctx.statusClasses]),
    "data-cy": `coursePreview_${_ctx.stream.id}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isShowAccessText)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["access", _ctx.statusClasses])
          }, _toDisplayString(_ctx.accessText), 3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCourse && _ctx.openCourse(...args))),
      class: "content"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["title", _ctx.statusClasses])
        }, _toDisplayString(_ctx.course.caption), 3),
        (_ctx.isShowRenewBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["btn", _ctx.statusClasses])
            }, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.continueBtnText), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (_ctx.courseImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "preview",
              src: _ctx.courseImage,
              alt: ""
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCourse && _ctx.openCourse(...args))),
      class: _normalizeClass(["progress", _ctx.statusClasses])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "progress_fill",
          style: _normalizeStyle({ width: `${_ctx.progress}%` })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_ctx.progress) + "%", 1),
        _hoisted_9
      ])
    ], 2),
    (_ctx.showRenewCourse)
      ? (_openBlock(), _createBlock(_component_as_renew_course_mobile, {
          key: 0,
          stream: _ctx.stream,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRenewCourse = false))
        }, null, 8, ["stream"]))
      : _createCommentVNode("", true),
    (_ctx.showModalCritical)
      ? (_openBlock(), _createBlock(_component_as_modal_critical_renew, {
          key: 1,
          stream: _ctx.stream,
          course: _ctx.course,
          "onClick:renew": _ctx.onShowRenewModal,
          "onClick:remind": _ctx.remindLater
        }, null, 8, ["stream", "course", "onClick:renew", "onClick:remind"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}